(() => {
  if (window.__muranoBlackNovV3Initialized) return;
  window.__muranoBlackNovV3Initialized = true;
  const active = new Map();
  function mount(root) {
    if (active.has(root)) return;
    const target = Date.parse(root.dataset.startsAt);
    const accessible = root.querySelector('[data-timer-accessible]');
    const started = root.querySelector('[data-campaign-started]');
    const preview = root.querySelector('#signup-preview');
    const preventPreview = event => event.preventDefault();
    if (preview) preview.addEventListener('submit', preventPreview);
    let interval;
    function tick() {
      if (!Number.isFinite(target)) {
        accessible.textContent = root.dataset.invalidDate;
        started.hidden = true;
        return;
      }
      const remaining = Math.max(0, Math.floor((target - Date.now()) / 1000));
      const values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor(remaining / 3600) % 24,
        minutes: Math.floor(remaining / 60) % 60,
        seconds: remaining % 60
      };
      for (const [key, value] of Object.entries(values)) {
        const digit = root.querySelector('[data-unit="' + key + '"]');
        if (digit) digit.textContent = String(value).padStart(2, '0');
      }
      accessible.textContent = root.dataset.timerFormat.replace(/__(days|hours|minutes|seconds)__/g, (_, key) => values[key]);
      started.hidden = remaining > 0;
      if (!remaining && interval) clearInterval(interval);
    }
    tick();
    if (Number.isFinite(target) && target > Date.now()) interval = setInterval(tick, 1000);
    active.set(root, () => {
      if (interval) clearInterval(interval);
      if (preview) preview.removeEventListener('submit', preventPreview);
    });
  }
  function scan(parent) {
    if (parent.matches && parent.matches('[data-murano-captacao]')) mount(parent);
    parent.querySelectorAll('[data-murano-captacao]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of active) {
      if (event.target === root || event.target.contains(root)) { cleanup(); active.delete(root); }
    }
  });
})();
